import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

type CoachState = {
  loading: boolean;
  coachInfo: unknown | null;
  error: boolean;
  errorMessage: unknown | null;
};

const initialState: CoachState = {
  loading: false,
  coachInfo: null,
  error: false,
  errorMessage: null,
};

export const getCoachInfo = createAsyncThunk<
  unknown,
  void,
  { rejectValue: unknown }
>('getCoachInfo', async (_, thunkAPI) => {
  try {
    const { data } = await api.get('/api/coaches/me');
    const payload = data?.response ?? data;
    return payload;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response ?? 'Failed to load coach info.'
    );
  }
});

const getCoachSlice = createSlice({
  name: 'getCoach',
  initialState,
  reducers: {
    resetCoach: (state) => {
      state.loading = false;
      state.coachInfo = null;
      state.error = false;
      state.errorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCoachInfo.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = '';
    });
    builder.addCase(getCoachInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.coachInfo = action.payload;
    });
    builder.addCase(getCoachInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage =
        action.payload ?? action.error.message ?? 'Failed to load coach info.';
    });
  },
});

export const { resetCoach } = getCoachSlice.actions;
export default getCoachSlice.reducer;
